import { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { getAlertsUnreadCount } from '../services/api';

/**
 * AlertsBell — top-nav notification bell with live unread badge.
 * Polls every 60s. Click → /alerts.
 */
export default function AlertsBell() {
  const [count, setCount] = useState(0);
  const [hasHigh, setHasHigh] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const res = await getAlertsUnreadCount();
      setCount(res.data.count || 0);
      setHasHigh((res.data.high_severity || 0) > 0);
    } catch (e) {
      // silent — bell stays at 0 on error
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 60000);
    return () => clearInterval(id);
  }, [refresh]);

  const display = count > 99 ? '99+' : count;

  return (
    <Link
      to="/alerts"
      className="relative inline-flex items-center justify-center w-10 h-10 rounded-full transition-colors hover:bg-[#F7F6F2]"
      aria-label={`${count} unread alerts`}
      data-testid="alerts-bell"
    >
      <Bell size={18} style={{ color: hasHigh ? '#D98A4A' : '#4B5563' }} strokeWidth={2} />
      {count > 0 && (
        <span
          className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full flex items-center justify-center text-[10px] font-mono font-bold leading-none"
          style={{
            background: hasHigh ? '#D98A4A' : '#0A3622',
            color: '#FFFFFF',
            boxShadow: '0 0 0 2px #FFFFFF',
          }}
          data-testid="alerts-bell-badge"
        >
          {display}
        </span>
      )}
    </Link>
  );
}
